import { useFormContext } from 'react-hook-form';
import { RadioField, NumberSelectField } from '@views/register/history/history-fields';
import type { IHistoryDiagnosedFormValues, IHistoryDiagnosedModel } from '@/types/history/history-diagnosed';
import type { TLocalize } from '@hooks/use-localize';
import FieldError from '@components/field-error';

interface IProps {
    model: IHistoryDiagnosedModel;
    t: TLocalize;
}

const WomensHealthSection = ({ model, t }: IProps) => {
    const {
        watch,
        register,
        formState: { errors },
    } = useFormContext<IHistoryDiagnosedFormValues>();

    const ms = model.medicalHistoryStatusOptions;
    const yn = model.yesNoUnknownOptions;
    const yes = String(model.yesValue);
    const please = t('DashLabel_PleaseSelect', 'Please Select');

    return (
        <>
            <div className='section-heading'>Womens Health</div>

            {!model.useReducedQuestions && (
                <>
                    <RadioField
                        name="historyFibroidUterus"
                        label={t('DashLabel_DoYouHaveAHistoryOfFibroidUterus', 'Do you have a history of Fibroid Uterus')}
                        options={ms}
                    />
                    <RadioField
                        name="historyEndometriosis"
                        label={t('DashLabel_DoYouHaveAHistoryOfEndometriosis', 'Do you have a history of Endometriosis')}
                        options={ms}
                    />
                    <RadioField
                        name="historyPolycysticOvaries"
                        label={t('DashLabel_DoYouHaveAHistoryOfPolycysticOvaries', 'Do you have a history of Polycystic Ovaries')}
                        options={ms}
                    />
                </>
            )}

            <RadioField
                name="hasHadMiscarriages"
                label={t('DashLabel_HaveYouEverHadAMiscarriage', 'Have you ever had a miscarriage')}
                options={yn}
            />

            {watch('hasHadMiscarriages') === yes && (
                <div className="sub-question">
                    <NumberSelectField
                        name="howManyMiscarriages"
                        label={t('DashLabel_HowManyMiscarriages', 'How many miscarriages')}
                        max={5}
                        plusLast
                        placeholder={please}
                    />
                    <div className="form-group">
                        <label className="control-label col-xs-12">
                            {t('DashLabel_DidYouEverMiscarryDuringThe2NdAndOr3RdTrimester', 'Did you ever miscarry during the 2nd and/or 3rd trimester')}?
                            <FieldError message={errors.hadLateMiscarriage?.message} />
                        </label>
                        <div className="col-xs-12">
                            <label className="radio-inline">
                                <input type="radio" value="1" {...register('hadLateMiscarriage')} /> {t('Word_Yes', 'Yes')}
                            </label>
                            <label className="radio-inline">
                                <input type="radio" value="0" {...register('hadLateMiscarriage')} /> {t('Word_No', 'No')}
                            </label>
                        </div>
                    </div>
                </div>
            )}

            {!model.useReducedQuestions && (
                <>
                    <RadioField
                        name="hasHadAbortions"
                        label={t('DashLabel_HaveYouEverHadAnAbortion', 'Have you ever had an abortion')}
                        options={yn}
                    />
                    {watch('hasHadAbortions') === yes && (
                        <div className="sub-question">
                            <NumberSelectField
                                name="howManyAbortions"
                                label={t('DashLabel_HowManyAbortions', 'How many abortions')}
                                max={5}
                                plusLast
                                placeholder={please}
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default WomensHealthSection;
